import { OhatStatus } from './status';

export class Choice {
  public constructor(
    public readonly status: OhatStatus,
    public readonly imageSrc: string,
    public readonly description: string[],
  ) {}
}
